// Multi-language translations for Brothers Taxi
// Supported: sq (Albanian - default), en (English), it (Italian)

export const translations = {
  sq: {
    nav: {
      home: "Kreu",
      about: "Rreth Nesh",
      services: "Shërbimet",
      airport: "Aeroport",
      fleet: "Flota",
      pricing: "Çmimet",
      contact: "Kontakt",
      book: "Rezervo Taxi",
    },
    common: {
      callNow: "Telefono Tani",
      bookNow: "Rezervo Tani",
      bookTaxi: "Rezervo Taxi",
      learnMore: "Mëso më shumë",
      seeAll: "Shiko të Gjitha",
      readMore: "Lexo më shumë",
      whatsapp: "WhatsApp",
      available247: "24/7 në shërbimin tuaj",
      from: "nga",
      to: "drejt",
      backToHome: "Kthehu në Kreu",
      submit: "Dërgo",
      submitting: "Po dërgohet...",
      success: "Sukses!",
      error: "Diçka shkoi keq",
      fixedPrices: "Çmime fikse",
      noHiddenFees: "Pa pagesa shtesë",
      customers: "klientë",
      capacity: "Kapaciteti",
      luggage: "Bagazhi",
      duration: "Kohëzgjatja",
      distance: "Distanca",
      price: "Çmimi",
      waitingPerHour: "Pritje/orë",
      fixedPriceSedan: "Çmim fiks Sedan",
      flightTracking: "Ndjekje fluturimi",
      searchDestination: "Kërko destinacion...",
      noResults: "Asnjë rezultat. Telefono +355 68 22 22 286 për çmime të personalizuara.",
      all: "Të gjitha",
      bookYourRide: "Rezervo Udhëtimin",
      callLong: "Telefono +355 68 22 22 286",
      startingFrom: "Nga",
    },
    hero: {
      tagline: "Lushnjë • Tiranë • Bregdet",
      title: "Një Telefonatë Larg.",
      subtitle: "Kurdo. Kudo.",
      description: "Brothers Taxi - shërbim taxi profesional 24/7 në Lushnje dhe gjithë Shqipërinë. Korrektesi në orare, komoditet maksimal, çmime fikse.",
      ctaPrimary: "Rezervo Taxi",
      ctaSecondary: "Telefono +355 68 22 22 286",
    },
    stats: {
      years: "Vite Eksperiencë",
      trips: "Udhëtime të Sukseshme",
      cities: "Qytete të Mbuluara",
      support: "Mbështetje Klientit",
    },
    fleetPreview: {
      tag: "Flota Jonë",
      title: "Automjete moderne për çdo destinacion",
      subtitle: "Flota jonë kombinon automjetet elektrike me modelet premium për udhëtime të qeta, të sigurta dhe komode.",
      viewAll: "Shiko të gjithë flotën",
      reserve: "Rezervo",
      cars: [
        {
          type: "id4",
          name: "Volkswagen ID.4",
          badge: "SUV Elektrik",
          desc: "SUV elektrik i bollshëm, ideal për aeroport dhe udhëtime të gjata.",
          specs: ["4 pasagjerë", "3-4 valixhe", "Elektrike"],
          footer: "Aeroport · Distanca të gjata",
        },
        {
          type: "byd",
          name: "BYD Song Plus",
          badge: "SUV Premium Elektrik",
          desc: "Hapësirë dhe komoditet për familje, biznes dhe destinacione turistike.",
          specs: ["4 pasagjerë", "4 valixhe", "Elektrike"],
          footer: "Familje · Turizëm · Biznes",
        },
        {
          type: "gla",
          name: "Mercedes-Benz GLA 2025",
          badge: "SUV Premium",
          desc: "Shërbim premium për transferta biznesi, private dhe klientë VIP.",
          specs: ["4 pasagjerë", "3 valixhe", "Model 2025"],
          footer: "Biznes · VIP · Privat",
        },
      ],
    },
    home: {
      whyTitle: "Pse të Zgjedhësh Brothers Taxi",
      whySubtitle: "Komoditet në çdo kilometër",
      reasons: [
        { title: "Korrektesi në Orare", desc: "Jemi gjithmonë në kohë për fluturimin apo udhëtimin tuaj." },
        { title: "Komoditet & Pastërti", desc: "Makina premium, të pastra, komode për çdo udhëtim." },
        { title: "Çmime Fikse", desc: "Pa surpriza. Çmimi që sheh është çmimi që paguan." },
        { title: "Shërbim 24/7", desc: "Operojmë natë e ditë, çdo ditë të vitit." },
        { title: "Drejtues Profesionistë", desc: "Të licencuar, të edukuar dhe me përvojë të gjatë." },
        { title: "Mbulim Kombëtar", desc: "Nga Lushnja drejt çdo qyteti në Shqipëri." },
      ],
      destinationsTitle: "Destinacionet Tona Më të Kërkuara",
      destinationsSubtitle: "Drejt bregdetit. Drejt qytetit. Drejt aeroportit.",
      ctaTag: "Rezervoni udhëtimin",
      ctaBlockTitle: "Gati për udhëtimin tuaj?",
      ctaBlockSubtitle: "Udhëtoni me automjete moderne, shoferë profesionistë dhe shërbim të organizuar për çdo destinacion në Shqipëri.",
      testimonialsTag: "Vlerësimet",
      testimonialsTitle: "Çfarë thonë klientët tanë",
      testimonialsScore: "TrustScore",
      testimonialsRatingLabel: "Shkëlqyeshëm",
      testimonialsReviews: "vlerësime",
      testimonialsVerified: "I verifikuar",
      testimonials: [
        { quote: "Shoferi na priti në aeroport në kohë. Automjeti ishte shumë i pastër dhe udhëtimi për në Vlorë ishte i qetë.", name: "Marco R.", country: "Itali", flag: "🇮🇹", date: "12 Janar 2026" },
        { quote: "Komunikim shumë i mirë përpara mbërritjes dhe shërbim profesional gjatë gjithë transfertës.", name: "Anna K.", country: "Gjermani", flag: "🇩🇪", date: "5 Janar 2026" },
        { quote: "Rezervimi ishte i thjeshtë dhe shoferi na ndihmoi me bagazhet. Do ta përdorim përsëri.", name: "James W.", country: "Mbretëria e Bashkuar", flag: "🇬🇧", date: "28 Dhjetor 2025" },
        { quote: "Çmim korrekt, makinë elektrike shumë komode, i rekomandoj për të shkuar në Ksamil.", name: "Endri H.", country: "Shqipëri", flag: "🇦🇱", date: "20 Dhjetor 2025" },
        { quote: "Un service ponctuel et un chauffeur très aimable. Parfait pour le transfert Rinas–Sarandë.", name: "Camille D.", country: "Francë", flag: "🇫🇷", date: "15 Dhjetor 2025" },
        { quote: "Servizio impeccabile, auto elettrica silenziosa e prezzo trasparente. Consigliato al 100%.", name: "Giulia F.", country: "Itali", flag: "🇮🇹", date: "3 Dhjetor 2025" },
      ],
    },
    whyBrothers: {
      tag: "Pse Brothers Taxi",
      title: "Një shërbim që fillon përpara udhëtimit",
      subtitle: "Rezervimi, komunikimi dhe organizimi janë po aq të rëndësishëm sa vetë udhëtimi.",
      items: [
        { title: "Rezervim i thjeshtë", desc: "Rezervoni online ose na kontaktoni drejtpërdrejt për të organizuar transfertën." },
        { title: "Pritje në kohë", desc: "Shoferi organizohet sipas orarit dhe pikës së përcaktuar të marrjes." },
        { title: "Çmime transparente", desc: "Detajet dhe çmimi i udhëtimit konfirmohen përpara nisjes." },
        { title: "Mbështetje 24/7", desc: "Jemi të disponueshëm për ndryshime, vonesa fluturimesh dhe kërkesa të veçanta." },
      ],
    },
    about: {
      title: "Rreth Brothers Taxi",
      subtitle: "Histori familjare. Shërbim profesional.",
      content: [
        "Brothers Taxi është themeluar nga dy vëllezër me një vizion të thjeshtë: t'i ofrojnë Shqipërisë një shërbim taxi që ndërthur besueshmërinë familjare me profesionalizmin e nivelit europian.",
        "Që nga dita e parë, ne kemi vendosur prioritetet tona në siguri, komoditet dhe korrektesi. Çdo udhëtim me ne nuk është vetëm një transport – është një eksperiencë premium.",
        "Operojmë nga Lushnja drejt gjithë territorit shqiptar – nga aeroporti i Tiranës (Rinas), te plazhet e bukura të Sarandës dhe Ksamilit, deri te qytetet e brendshme.",
      ],
      missionTitle: "Misioni Ynë",
      mission: "Të ndryshojmë mënyrën se si udhëtohet në Shqipëri – duke ofruar siguri, komoditet dhe besueshmëri në çdo kilometër.",
      visionTitle: "Vizioni Ynë",
      vision: "Të bëhemi shërbimi numër 1 i transportit privat në Shqipëri, duke vendosur standardin e ri për cilësi në industri.",
    },
    services: {
      title: "Shërbimet Tona",
      subtitle: "Çdo udhëtim – një zgjidhje",
      items: [
        { name: "Taxi në Qytet", desc: "Shërbim taxi 24/7 brenda Lushnjes dhe qyteteve përreth.", icon: "MapPin" },
        { name: "Airport Transfer", desc: "Transport direkt drejt/nga Aeroporti TIA (Rinas) - çmime fikse.", icon: "Plane" },
        { name: "Udhëtime të Gjata", desc: "Drejt çdo qyteti në Shqipëri me çmime të llogaritura paraprakisht.", icon: "Route" },
        { name: "Udhëtime Bregdetare", desc: "Sarandë, Ksamil, Dhërmi, Himarë, Vlorë - vera juaj fillon këtu.", icon: "Sun" },
        { name: "Rezervime Korporative", desc: "Marrëveshje speciale për kompani dhe partnerë biznesi.", icon: "Briefcase" },
        { name: "Eventet & Dasmat", desc: "Transport elegant për ditët tuaja të veçanta.", icon: "Heart" },
      ],
    },
    airport: {
      title: "Airport Transfer",
      subtitle: "Aeroporti TIA (Rinas) - i pari në mendje, i pari në kohë",
      description: "Specialistët e transferimit nga dhe drejt Aeroportit Ndërkombëtar të Tiranës. Drejtuesit tanë monitorojnë fluturimin tuaj në kohë reale.",
      features: [
        "Monitorim i fluturimit në kohë reale",
        "Drejtuesi ju pret me emrin tuaj në portë",
        "Asnjë tarifë shtesë për vonesat e fluturimit",
        "Mund të rezervoni deri 30 ditë para",
        "Pranojmë cash, kartë dhe transfer bankar",
        "Bagazh i pakufizuar – pa pagesë shtesë",
      ],
      ctaTitle: "Rezervo Airport Transfer",
      ctaDesc: "Sigurohuni që fluturimi juaj fillon dhe mbaron pa stres.",
    },
    fleet: {
      title: "Flota Jonë",
      subtitle: "Automjete moderne, elektrike dhe komode për transferta aeroporti, udhëtime ndërqytetëse, udhëtime biznesi dhe destinacione në të gjithë Shqipërinë.",
      ctaVehicles: "Automjetet Tona",
      vehicles: [
        { name: "Volkswagen ID.4", capacity: "1-4 pasagjerë", luggage: "3-4 valixhe", desc: "Airport transfer premium në stil europian. SUV elektrik i qetë, i sigurt dhe komod – ideal për udhëtimin Lushnjë–Rinas.", type: "id4" },
        { name: "MG MG4", capacity: "1-4 pasagjerë", luggage: "2-3 valixhe", desc: "Hatchback elektrik dinamik për qytet dhe udhëtime të mesme. I shpejtë, i lehtë dhe pa emisione – të lëviz pa zhurmë.", type: "mg4" },
        { name: "BYD Song Plus", capacity: "1-4 pasagjerë", luggage: "3-4 valixhe", desc: "SUV elektrik i madh dhe komod. I preferuari ynë për udhëtime të gjata drejt Sarandës, Ksamilit dhe Rivierës Shqiptare.", type: "byd" },
      ],
      electric: {
        tag: "Flota elektrike",
        title: "Udhëtime më të qeta dhe më të pastra",
        subtitle: "Pjesa kryesore e flotës sonë përbëhet nga automjete elektrike. Volkswagen ID.4, BYD Song Plus dhe MG4 ofrojnë një udhëtim të qetë, komod dhe pa emetime nga marmita.",
        items: [
          { title: "Automjete plotësisht elektrike", desc: "Teknologji moderne për udhëtime të sigurta dhe efikase." },
          { title: "Më pak zhurmë gjatë udhëtimit", desc: "Kabina më e qetë krijon më shumë rehati për pasagjerët." },
          { title: "Zero emetime nga marmita", desc: "Një zgjedhje më e përgjegjshme për qytetet dhe mjedisin." },
        ],
      },
      ctaTitle: "Nuk jeni të sigurt cilin automjet të zgjidhni?",
      ctaDesc: "Na tregoni destinacionin, numrin e pasagjerëve dhe sasinë e bagazheve. Ne do t'ju vijmë me automjetin e duhur.",
    },
    pricing: {
      title: "Çmimet Tona",
      subtitle: "Të qarta. Të drejta. Pa surpriza.",
      headerFrom: "Nisja",
      headerTo: "Mbërritja",
      headerDuration: "Kohëzgjatja",
      headerDistance: "Distanca",
      headerPrice: "Çmimi",
      note: "Çmimet janë në Lek shqiptar (L), për një drejtim me makinë Sedan. Për SUV +20%, për Van +35%. Pritje shtesë faturohet veçmas sipas tarifave të mësipërme. 100 L ≈ 1 €.",
      empty: "Çmimet po ngarkohen...",
    },
    booking: {
      title: "Rezervo Taxinë Tënde",
      subtitle: "Plotëso formularin dhe ne do t'ju kontaktojmë brenda 5 minutash",
      fields: {
        fullName: "Emër Mbiemër",
        phone: "Telefoni",
        email: "Email (opsionale)",
        pickupLocation: "Vendi i nisjes",
        dropoffLocation: "Destinacioni",
        pickupDate: "Data",
        pickupTime: "Ora",
        passengers: "Pasagjerë",
        luggage: "Valixhe",
        vehicleType: "Lloji i makinës",
        serviceType: "Lloji i shërbimit",
        flightNumber: "Numri i Fluturimit (për Airport)",
        notes: "Shënime shtesë",
      },
      vehicleTypes: { sedan: "Sedan", suv: "SUV", van: "Van/Minivan" },
      serviceTypes: { city: "Brenda Qytetit", airport: "Airport Transfer", long_distance: "Udhëtim i Gjatë", coastal: "Bregdet" },
      submit: "Konfirmo Rezervimin",
      success: "Rezervimi u krye me sukses! Do t'ju kontaktojmë brenda pak minutash.",
      error: "Gabim gjatë rezervimit. Ju lutemi provoni përsëri ose telefononi direkt.",
      placeholders: {
        fullName: "P.sh. Arben Hoxha",
        phone: "+355 68 ...",
        email: "ju@email.com",
        pickup: "P.sh. Lushnjë, qendër",
        dropoff: "P.sh. Aeroporti Rinas",
        notes: "Kërkesa speciale, etj.",
      },
    },
    contact: {
      title: "Na Kontaktoni",
      subtitle: "Jemi gjithmonë afër – një telefonatë, mesazh ose vizitë larg.",
      badge: "Ne jemi këtu",
      openLabel: "Në linjë tani",
      responseLabel: "Përgjigje mesatare",
      responseTime: "5 min",
      quickTitle: "Bisedë e shpejtë",
      quickDesc: "Preferoni WhatsApp? Mesazhi juaj arrin drejt e te ekipi ynë. Rezervoni, pyesni për çmimin ose kërkoni një ndalesë të veçantë.",
      callTitle: "Telefono",
      emailTitle: "Email",
      whatsappTitle: "WhatsApp",
      locationTitle: "Lokacioni",
      locationValue: "Lushnjë, Shqipëri",
      formTitle: "Dërgo një Mesazh",
      formSubtitle: "Shkruani atë që ju nevojitet – destinacion, orar, kërkesa speciale. Ju përgjigjemi brenda 5 minutash.",
      fields: { name: "Emri", email: "Email", phone: "Telefoni", subject: "Tema", message: "Mesazhi" },
      submit: "Dërgo Mesazhin",
      success: "Mesazhi u dërgua me sukses! Do t'ju përgjigjemi sa më shpejt.",
      error: "Gabim. Ju lutem provoni përsëri.",
    },
    footer: {
      tagline: "Shërbim taxi profesional 24/7. Lushnjë & gjithë Shqipëria.",
      quickLinks: "Linke të Shpejta",
      services: "Shërbimet",
      contact: "Kontakti",
      rights: "Të gjitha të drejtat e rezervuara.",
      legal: "Politika e Privatësisë",
    },
    accents: {
      whereNext: "Ku po shkoni më pas?",
      noSurprises: "Pa surpriza —",
      noStress: "Pa stres —",
      fromHeart: "Nga zemra e Lushnjes —",
      whateverNeeded: "Çfarëdo që ju nevojitet —",
      hello: "Pershendetje —",
      premiumComfort: "Komoditet premium —",
      soSimple: "Sa thjesht —",
      trustedOne: "i besueshmi",
      pricingTag: "Tarifa Brothers Taxi",
      airportTag: "Aeroport",
      coastTag: "Riviera",
    },
    seoBlock: {
      heading1: "Taxi në Lushnje 24/7 —",
      heading2: "i besueshmi",
      heading3: "i taksive",
      p1: "Brothers Taxi është shërbimi më i besueshëm i taxi në Lushnje. Operojmë çdo ditë të vitit, 24 orë në ditë, me një flotë makinash premium dhe drejtues profesionistë të licencuar. Nëse keni nevojë për taxi Lushnje Tiranë, taxi Lushnje aeroport Rinas, ose udhëtim drejt bregdetit, ne jemi vetëm një telefonatë larg.",
      p2: "Specializohemi në airport transfer nga Lushnja drejt Aeroportit TIA (Rinas) me çmim fiks prej 3.500 L, si dhe udhëtime të gjata drejt Sarandës, Ksamilit, Dhërmit, Himarës, Vlorës, Durrësit, Beratit, Shkodrës dhe Korçës.",
      p3Pre: "Mbulojmë gjithashtu",
      p3Strong: "fshatrat përreth Lushnjes",
      p3Mid: "dhe mbi 100 destinacione të tjera. Na kontaktoni në",
      p3Post: ".",
    },
    seo: {
    home: {
        title: "Taxi në Lushnje 24/7 | Brothers Taxi - Airport Transfer Rinas, Sarandë, Ksamil",
        description: "Taxi në Lushnje 24/7 me Brothers Taxi. Çmime fikse, makina premium, airport transfer Tiranë (Rinas) 3500 L, udhëtime Sarandë & Ksamil 9000-10000 L. Telefono +355 68 22 22 286. Rezervo online.",
        keywords: "taxi Lushnje, taxi në Lushnje, taxi Lushnje Tiranë, taxi Lushnje aeroport, taxi Lushnje Rinas, taksi Lushnje, taxi Sarandë nga Lushnja, taxi Ksamil nga Lushnja, airport transfer Lushnje, Brothers Taxi, taxi 24/7 Lushnje, transport privat Lushnje, taxi për Vlorë nga Lushnja, taxi Durrës Lushnje, taxi Berat Lushnje, taksi bregdet Shqipëri, taxi nga Lushnja, çmime taxi Lushnje, taxi i lirë Lushnje",
      },
      about: {
        title: "Rreth Brothers Taxi | Histori Familjare në Lushnje - Shërbim Taxi 24/7",
        description: "Brothers Taxi është themeluar nga dy vëllezër me vizion: t'i ofrojnë Shqipërisë taxi profesional. Misioni, vizioni dhe vlerat tona. 10+ vite eksperiencë, 25.000+ udhëtime në Lushnjë & gjithë Shqipërinë.",
        keywords: "rreth Brothers Taxi, kompani taxi Lushnje, taxi familjar Shqipëri, taxi profesional Lushnje, historia Brothers Taxi, kompani transporti Lushnje, taxi i licencuar Shqipëri",
      },
      services: {
        title: "Shërbimet Tona Taxi | Brothers Taxi Lushnje - Airport, Bregdet, Korporata",
        description: "Shërbime taxi në Lushnje: taxi brenda qytetit, airport transfer Tiranë Rinas, udhëtime të gjata në Shqipëri, udhëtime bregdetare (Sarandë, Ksamil, Dhërmi, Himarë, Vlorë), rezervime korporative, eventet & dasma. 24/7.",
        keywords: "shërbim taxi Lushnje, airport transfer Tiranë, taxi qyteti Lushnje, udhëtime të gjata Shqipëri, taxi bregdet, taxi dasme Lushnje, taxi korporativ Shqipëri, taxi për Sarandë, taxi për Ksamil, taxi për Dhërmi, taxi për Himarë, taxi për Vlorë, transport eventesh Lushnje",
      },
      airport: {
        title: "Airport Transfer Tiranë (Rinas) nga Lushnja | Brothers Taxi - 3500 L Fiks",
        description: "Transferim taxi nga Lushnja drejt Aeroportit Ndërkombëtar të Tiranës (Rinas/TIA) për 3500 L. Monitorim fluturimi në kohë reale, drejtues të licencuar, pa stres, pa tarifa të fshehura. 24/7. Telefono +355 68 22 22 286.",
        keywords: "airport transfer Tiranë, taxi Rinas Lushnje, taxi aeroport Lushnje, transfer aeroport Tiranë, taxi për TIA, taxi për Rinas, taxi Lushnje Rinas çmim, taxi Lushnje aeroport, transfer Tiranë aeroport, taxi 24/7 Rinas",
      },
      fleet: {
        title: "Flota Jonë | Sedan, SUV & Van Premium - Brothers Taxi Lushnje",
        description: "Makina premium për çdo udhëtim: Sedan (1-3 pasagjerë, Volkswagen/Skoda), SUV komod (1-4), Van/Minivan (5-8). Pastërti, siguri dhe komoditet maksimal për taxi në Lushnje dhe gjithë Shqipërinë.",
        keywords: "flota Brothers Taxi, taxi sedan Lushnje, taxi SUV Lushnje, taxi van Lushnje, taxi për grupe Lushnje, makina taxi premium Shqipëri, taxi familjar Lushnje, taxi 8 vende Lushnje, minivan taxi Shqipëri",
      },
      pricing: {
        title: "Çmime Taxi nga Lushnja | 114+ Destinacione | Brothers Taxi - Lista e Plotë",
        description: "Lista e plotë e çmimeve fikse për taxi nga Lushnja: Tiranë 4000 L, Rinas 3500 L, Sarandë 9000 L, Ksamil 10000 L, Durrës 3000 L, Vlorë 5000 L, Berat 2500 L, Korçë 8000 L. Mbi 114 rute me çmime transparente.",
        keywords: "çmime taxi Lushnje, tarifa taxi Lushnje, çmim taxi Lushnje Tiranë, çmim taxi Lushnje Rinas, çmim taxi Lushnje Sarandë, çmim taxi Lushnje Ksamil, taksimetri Lushnje, çmim taxi Lushnje Durrës, çmim taxi Lushnje Vlorë, çmim taxi Lushnje Berat, çmime fikse taxi Shqipëri",
      },
      contact: {
        title: "Kontakt Brothers Taxi Lushnje | +355 68 22 22 286 - 24/7 WhatsApp & Email",
        description: "Kontakto Brothers Taxi në Lushnje: Telefon +355 68 22 22 286, WhatsApp i njëjti numër, Email booking@brotherstaxi.al. Adresa: Lushnjë, Shqipëri. Shërbim taxi 24 orë në ditë, 7 ditë në javë.",
        keywords: "kontakt Brothers Taxi, numri taxi Lushnje, telefon taxi Lushnje, WhatsApp taxi Lushnje, email Brothers Taxi, adresa taxi Lushnje, taxi Lushnje 24/7",
      },
      book: {
        title: "Rezervo Taxi Online në Lushnje | Brothers Taxi - Konfirmim në 5 Minuta",
        description: "Rezervo taxi online në Lushnje me Brothers Taxi. Plotëso formularin për airport transfer, taxi qyteti ose udhëtim bregdetar. Konfirmim brenda 5 minutash. Ose telefono direkt +355 68 22 22 286.",
        keywords: "rezervo taxi Lushnje, taxi online Lushnje, prenoto taxi Shqipëri, rezervo taxi airport Tiranë, rezervim online taxi Lushnje, booking taxi Lushnje",
      },
    },
  },

  en: {
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      airport: "Airport",
      fleet: "Fleet",
      pricing: "Pricing",
      contact: "Contact",
      book: "Book a Taxi",
    },
    common: {
      callNow: "Call Now",
      bookNow: "Book Now",
      bookTaxi: "Book a Taxi",
      learnMore: "Learn more",
      seeAll: "See All",
      readMore: "Read more",
      whatsapp: "WhatsApp",
      available247: "24/7 at your service",
      from: "from",
      to: "to",
      backToHome: "Back to Home",
      submit: "Submit",
      submitting: "Submitting...",
      success: "Success!",
      error: "Something went wrong",
      fixedPrices: "Fixed prices",
      noHiddenFees: "No hidden fees",
      customers: "customers",
      capacity: "Capacity",
      luggage: "Luggage",
      duration: "Duration",
      distance: "Distance",
      price: "Price",
      waitingPerHour: "Wait/hour",
      fixedPriceSedan: "Fixed Sedan price",
      flightTracking: "Flight tracking",
      searchDestination: "Search destination...",
      noResults: "No results found. Call +355 68 22 22 286 for a custom quote.",
      all: "All",
      bookYourRide: "Book Your Ride",
      callLong: "Call +355 68 22 22 286",
      startingFrom: "From",
    },
    hero: {
      tagline: "Lushnje • Tirana • Albanian Coast",
      title: "One Call Away.",
      subtitle: "Anytime. Anywhere.",
      description: "Brothers Taxi - professional 24/7 taxi service in Lushnje and all of Albania. On-time arrivals, premium comfort, fixed prices.",
      ctaPrimary: "Book a Taxi",
      ctaSecondary: "Call +355 68 22 22 286",
    },
    stats: {
      years: "Years of Experience",
      trips: "Successful Trips",
      cities: "Cities Covered",
      support: "Customer Support",
    },
    fleetPreview: {
      tag: "Our Fleet",
      title: "Modern vehicles for every destination",
      subtitle: "Our fleet combines electric vehicles with premium models for quiet, safe and comfortable rides.",
      viewAll: "See the full fleet",
      reserve: "Reserve",
      cars: [
        {
          type: "id4",
          name: "Volkswagen ID.4",
          badge: "Electric SUV",
          desc: "Spacious electric SUV — perfect for airport runs and long trips.",
          specs: ["4 passengers", "3-4 suitcases", "Electric"],
          footer: "Airport · Long distance",
        },
        {
          type: "byd",
          name: "BYD Song Plus",
          badge: "Premium Electric SUV",
          desc: "Space and comfort for families, business travel and tourism.",
          specs: ["4 passengers", "4 suitcases", "Electric"],
          footer: "Family · Tourism · Business",
        },
        {
          type: "gla",
          name: "Mercedes-Benz GLA 2025",
          badge: "Premium SUV",
          desc: "Premium service for business transfers, private rides and VIP clients.",
          specs: ["4 passengers", "3 suitcases", "2025 model"],
          footer: "Business · VIP · Private",
        },
      ],
    },
    home: {
      whyTitle: "Why Choose Brothers Taxi",
      whySubtitle: "Comfort on every kilometer",
      reasons: [
        { title: "On-Time Always", desc: "We are always on time for your flight or trip." },
        { title: "Comfort & Cleanliness", desc: "Premium, clean cars - comfortable for every ride." },
        { title: "Fixed Prices", desc: "No surprises. The price you see is what you pay." },
        { title: "24/7 Service", desc: "We operate day and night, every day of the year." },
        { title: "Professional Drivers", desc: "Licensed, polite and highly experienced." },
        { title: "Nationwide Coverage", desc: "From Lushnje to any city across Albania." },
      ],
      destinationsTitle: "Our Most Popular Destinations",
      destinationsSubtitle: "To the coast. To the city. To the airport.",
      ctaTag: "Book your ride",
      ctaBlockTitle: "Ready for your ride?",
      ctaBlockSubtitle: "Travel with modern vehicles, professional drivers and a well-organised service to every destination in Albania.",
      testimonialsTag: "Reviews",
      testimonialsTitle: "What our customers say",
      testimonialsScore: "TrustScore",
      testimonialsRatingLabel: "Excellent",
      testimonialsReviews: "reviews",
      testimonialsVerified: "Verified",
      testimonials: [
        { quote: "The driver was waiting for us at the airport on time. The car was very clean and the ride to Vlore was smooth.", name: "Marco R.", country: "Italy", flag: "🇮🇹", date: "Jan 12, 2026" },
        { quote: "Great communication before arrival and a professional service throughout the transfer.", name: "Anna K.", country: "Germany", flag: "🇩🇪", date: "Jan 5, 2026" },
        { quote: "Booking was simple and the driver helped us with our luggage. Will use again.", name: "James W.", country: "United Kingdom", flag: "🇬🇧", date: "Dec 28, 2025" },
        { quote: "Fair price, very comfortable electric car — highly recommended for a Ksamil trip.", name: "Endri H.", country: "Albania", flag: "🇦🇱", date: "Dec 20, 2025" },
        { quote: "Un service ponctuel et un chauffeur très aimable. Parfait pour le transfert Rinas–Sarandë.", name: "Camille D.", country: "France", flag: "🇫🇷", date: "Dec 15, 2025" },
        { quote: "Servizio impeccabile, auto elettrica silenziosa e prezzo trasparente. Consigliato al 100%.", name: "Giulia F.", country: "Italy", flag: "🇮🇹", date: "Dec 3, 2025" },
      ],
    },
    whyBrothers: {
      tag: "Why Brothers Taxi",
      title: "A service that begins before your ride",
      subtitle: "Booking, communication and organisation are just as important as the ride itself.",
      items: [
        { title: "Easy booking", desc: "Book online or contact us directly to arrange your transfer." },
        { title: "On-time pickup", desc: "The driver is scheduled at your exact time and pickup point." },
        { title: "Transparent prices", desc: "Trip details and the price are confirmed before departure." },
        { title: "24/7 support", desc: "We are available for changes, flight delays and special requests." },
      ],
    },
    about: {
      title: "About Brothers Taxi",
      subtitle: "A family story. A professional service.",
      content: [
        "Brothers Taxi was founded by two brothers with a simple vision: to bring Albania a taxi service that combines family reliability with European professionalism.",
        "Since day one, our priorities have been safety, comfort, and punctuality. Every trip with us is not just transportation – it's a premium experience.",
        "We operate from Lushnje to all of Albania – from Tirana Airport (Rinas) to the beautiful beaches of Saranda and Ksamil, and inland cities.",
      ],
      missionTitle: "Our Mission",
      mission: "To change the way people travel in Albania – by providing safety, comfort, and reliability on every kilometer.",
      visionTitle: "Our Vision",
      vision: "To become the #1 private transport service in Albania, setting a new quality standard for the industry.",
    },
    services: {
      title: "Our Services",
      subtitle: "Every journey - one solution",
      items: [
        { name: "City Taxi", desc: "24/7 taxi service in Lushnje and surrounding cities.", icon: "MapPin" },
        { name: "Airport Transfer", desc: "Direct transport to/from Tirana Airport (TIA) - fixed prices.", icon: "Plane" },
        { name: "Long Distance", desc: "To any city in Albania with pre-calculated prices.", icon: "Route" },
        { name: "Coastal Trips", desc: "Saranda, Ksamil, Dhermi, Himara, Vlore - your summer starts here.", icon: "Sun" },
        { name: "Corporate Booking", desc: "Special agreements for companies and business partners.", icon: "Briefcase" },
        { name: "Events & Weddings", desc: "Elegant transport for your special days.", icon: "Heart" },
      ],
    },
    airport: {
      title: "Airport Transfer",
      subtitle: "Tirana Airport (TIA / Rinas) - first in mind, first on time",
      description: "Transfer specialists to and from Tirana International Airport. Our drivers monitor your flight in real time.",
      features: [
        "Real-time flight monitoring",
        "Driver meets you at the gate with your name",
        "No extra fee for flight delays",
        "Book up to 30 days in advance",
        "We accept cash, card and bank transfer",
        "Unlimited luggage – no extra charge",
      ],
      ctaTitle: "Book Airport Transfer",
      ctaDesc: "Make sure your flight starts and ends stress-free.",
    },
    fleet: {
      title: "Our Fleet",
      subtitle: "Modern, electric and comfortable vehicles for airport transfers, intercity trips, business travel and destinations across Albania.",
      ctaVehicles: "Our Vehicles",
      vehicles: [
        { name: "Volkswagen ID.4", capacity: "1-4 passengers", luggage: "3-4 suitcases", desc: "European-style premium airport transfer. A quiet, safe and comfortable electric SUV — ideal for the Lushnje–Rinas run.", type: "id4" },
        { name: "MG MG4", capacity: "1-4 passengers", luggage: "2-3 suitcases", desc: "Dynamic electric hatchback for city rides and mid-range trips. Fast, agile and emission-free — you glide silently.", type: "mg4" },
        { name: "BYD Song Plus", capacity: "1-4 passengers", luggage: "3-4 suitcases", desc: "A large, comfortable electric SUV. Our favourite for longer trips to Saranda, Ksamil and the Albanian Riviera.", type: "byd" },
      ],
      electric: {
        tag: "Electric fleet",
        title: "Quieter and cleaner rides",
        subtitle: "Most of our fleet is fully electric. Volkswagen ID.4, BYD Song Plus and MG4 deliver a quiet, comfortable ride with zero tailpipe emissions.",
        items: [
          { title: "Fully electric vehicles", desc: "Modern technology for safe and efficient journeys." },
          { title: "A quieter drive", desc: "A calmer cabin means more comfort for every passenger." },
          { title: "Zero tailpipe emissions", desc: "A more responsible choice for our cities and the environment." },
        ],
      },
      ctaTitle: "Not sure which vehicle to pick?",
      ctaDesc: "Tell us the destination, the number of passengers and the amount of luggage. We'll show up with the right car for the job.",
    },
    pricing: {
      title: "Our Pricing",
      subtitle: "Clear. Fair. No surprises.",
      headerFrom: "From",
      headerTo: "To",
      headerDuration: "Duration",
      headerDistance: "Distance",
      headerPrice: "Price",
      note: "Prices in Albanian Lek (L), one-way with a Sedan. For SUV add 20%, for Van add 35%. Waiting time is billed separately at the rates above. 100 L ≈ 1 €.",
      empty: "Prices loading...",
    },
    booking: {
      title: "Book Your Taxi",
      subtitle: "Fill the form and we'll contact you within 5 minutes",
      fields: {
        fullName: "Full Name",
        phone: "Phone",
        email: "Email (optional)",
        pickupLocation: "Pickup location",
        dropoffLocation: "Destination",
        pickupDate: "Date",
        pickupTime: "Time",
        passengers: "Passengers",
        luggage: "Luggage",
        vehicleType: "Vehicle type",
        serviceType: "Service type",
        flightNumber: "Flight number (for Airport)",
        notes: "Additional notes",
      },
      vehicleTypes: { sedan: "Sedan", suv: "SUV", van: "Van/Minivan" },
      serviceTypes: { city: "City Ride", airport: "Airport Transfer", long_distance: "Long Distance", coastal: "Coastal" },
      submit: "Confirm Booking",
      success: "Booking successfully submitted! We'll contact you in a few minutes.",
      error: "Booking error. Please try again or call directly.",
      placeholders: {
        fullName: "e.g. John Smith",
        phone: "+355 68 ...",
        email: "you@email.com",
        pickup: "e.g. Lushnje center",
        dropoff: "e.g. Rinas Airport",
        notes: "Special requests, etc.",
      },
    },
    contact: {
      title: "Contact Us",
      subtitle: "We are always close – a call, message or visit away.",
      badge: "We're right here",
      openLabel: "Online now",
      responseLabel: "Average reply",
      responseTime: "5 min",
      quickTitle: "Quick chat",
      quickDesc: "Prefer WhatsApp? Your message lands directly with our team. Book a ride, ask for a price, or request a special stop.",
      callTitle: "Call",
      emailTitle: "Email",
      whatsappTitle: "WhatsApp",
      locationTitle: "Location",
      locationValue: "Lushnje, Albania",
      formTitle: "Send us a Message",
      formSubtitle: "Tell us what you need – destination, timing, special requests. We reply within 5 minutes.",
      fields: { name: "Name", email: "Email", phone: "Phone", subject: "Subject", message: "Message" },
      submit: "Send Message",
      success: "Message sent successfully! We'll reply as soon as possible.",
      error: "Error. Please try again.",
    },
    footer: {
      tagline: "Professional 24/7 taxi service. Lushnje & all Albania.",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact",
      rights: "All rights reserved.",
      legal: "Privacy Policy",
    },
    accents: {
      whereNext: "Where to next?",
      noSurprises: "No surprises —",
      noStress: "No stress —",
      fromHeart: "From the heart of Lushnje —",
      whateverNeeded: "Whatever you need —",
      hello: "Hello —",
      premiumComfort: "Premium comfort —",
      soSimple: "So simple —",
      trustedOne: "the trusted",
      pricingTag: "Brothers Taxi Rates",
      airportTag: "Airport",
      coastTag: "Riviera",
    },
    seoBlock: {
      heading1: "Taxi in Lushnje 24/7 —",
      heading2: "the trusted",
      heading3: "name in taxis",
      p1: "Brothers Taxi is the most reliable taxi service in Lushnje. We operate every day of the year, 24 hours a day, with a premium fleet and licensed professional drivers. Whether you need a Lushnje–Tirana taxi, a Lushnje–Rinas airport taxi, or a coastal trip, we are just one call away.",
      p2: "We specialise in airport transfers from Lushnje to Tirana International Airport (TIA / Rinas) at a fixed rate of 3,500 L, as well as long-distance trips to Saranda, Ksamil, Dhermi, Himara, Vlore, Durres, Berat, Shkoder and Korce.",
      p3Pre: "We also cover",
      p3Strong: "the villages around Lushnje",
      p3Mid: "and over 100 other destinations. Contact us at",
      p3Post: ".",
    },
    seo: {
    home: {
        title: "Taxi in Lushnje 24/7 | Brothers Taxi - Tirana Airport Transfer, Saranda, Ksamil",
        description: "Taxi in Lushnje 24/7 with Brothers Taxi. Fixed prices, premium cars, Tirana Airport (Rinas) transfer 3500 L, trips to Saranda & Ksamil. Call +355 68 22 22 286 or book online.",
        keywords: "taxi Lushnje, Lushnje taxi, Lushnje to Tirana taxi, Lushnje airport taxi, Lushnje Rinas taxi, taxi Saranda from Lushnje, taxi Ksamil from Lushnje, airport transfer Lushnje, Brothers Taxi, 24/7 taxi Albania, private transfer Lushnje, taxi Albania coast, taxi Vlore Lushnje, taxi Durres Lushnje, Albanian taxi service, Lushnje taxi prices, cheap taxi Lushnje",
      },
      about: {
        title: "About Brothers Taxi | Family-Run Taxi Company in Lushnje, Albania",
        description: "Brothers Taxi was founded by two brothers with a vision: to deliver professional taxi service to Albania. Our mission, vision and values. 10+ years of experience, 25,000+ successful trips across Lushnje and Albania.",
        keywords: "about Brothers Taxi, Lushnje taxi company, family taxi Albania, professional taxi Lushnje, Brothers Taxi history, transport company Lushnje, licensed taxi Albania",
      },
      services: {
        title: "Our Taxi Services | Brothers Taxi Lushnje - Airport, Coast, Corporate",
        description: "Taxi services in Lushnje: city taxi, Tirana Rinas airport transfer, long-distance trips across Albania, coastal trips (Saranda, Ksamil, Dhermi, Himara, Vlore), corporate bookings, events & weddings. 24/7.",
        keywords: "Lushnje taxi service, Tirana airport transfer, city taxi Lushnje, long distance Albania, coastal taxi, wedding taxi Lushnje, corporate taxi Albania, taxi to Saranda, taxi to Ksamil, taxi to Dhermi, taxi to Himara, taxi to Vlore, event transport Lushnje",
      },
      airport: {
        title: "Tirana Airport (Rinas) Transfer from Lushnje | Brothers Taxi - Fixed 3500 L",
        description: "Taxi transfer from Lushnje to Tirana International Airport (Rinas / TIA) for a flat 3,500 L. Real-time flight monitoring, licensed drivers, stress-free, no hidden fees. 24/7. Call +355 68 22 22 286.",
        keywords: "Tirana airport transfer, Lushnje Rinas taxi, Lushnje airport taxi, Tirana airport transfer Albania, TIA taxi, Rinas taxi, Lushnje Rinas price, Lushnje airport price, 24/7 Rinas taxi",
      },
      fleet: {
        title: "Our Fleet | Premium Sedan, SUV & Van - Brothers Taxi Lushnje",
        description: "Premium vehicles for every trip: Sedan (1-3 passengers, Volkswagen/Skoda), comfort SUV (1-4), Van/Minivan (5-8). Cleanliness, safety and maximum comfort for taxi rides in Lushnje and across Albania.",
        keywords: "Brothers Taxi fleet, Lushnje sedan taxi, Lushnje SUV taxi, Lushnje van taxi, group taxi Lushnje, premium taxi vehicles Albania, family taxi Lushnje, 8-seat taxi Albania, minivan taxi Albania",
      },
      pricing: {
        title: "Taxi Prices from Lushnje | 114+ Destinations | Brothers Taxi - Full List",
        description: "Full list of fixed taxi prices from Lushnje: Tirana 4000 L, Rinas 3500 L, Saranda 9000 L, Ksamil 10000 L, Durres 3000 L, Vlore 5000 L, Berat 2500 L, Korce 8000 L. Over 114 routes with transparent pricing.",
        keywords: "Lushnje taxi prices, Lushnje taxi rates, Lushnje Tirana taxi price, Lushnje Rinas taxi price, Lushnje Saranda taxi price, Lushnje Ksamil taxi price, Lushnje Durres taxi price, Lushnje Vlore taxi price, Lushnje Berat taxi price, fixed taxi rates Albania",
      },
      contact: {
        title: "Contact Brothers Taxi Lushnje | +355 68 22 22 286 - 24/7 WhatsApp & Email",
        description: "Contact Brothers Taxi in Lushnje: Phone +355 68 22 22 286, WhatsApp same number, Email booking@brotherstaxi.al. Address: Lushnje, Albania. Taxi service 24 hours a day, 7 days a week.",
        keywords: "contact Brothers Taxi, Lushnje taxi number, Lushnje taxi phone, Lushnje WhatsApp taxi, Brothers Taxi email, Lushnje taxi address, Lushnje 24/7 taxi",
      },
      book: {
        title: "Book Taxi Online in Lushnje | Brothers Taxi - Confirmation in 5 Minutes",
        description: "Book a taxi online in Lushnje with Brothers Taxi. Fill the form for an airport transfer, city taxi or coastal trip. Confirmation within 5 minutes. Or call directly +355 68 22 22 286.",
        keywords: "book Lushnje taxi, online taxi Lushnje, book taxi Albania, book Tirana airport taxi, online booking taxi Lushnje, Lushnje taxi booking",
      },
    },
  },

  it: {
    nav: {
      home: "Home",
      about: "Chi Siamo",
      services: "Servizi",
      airport: "Aeroporto",
      fleet: "Flotta",
      pricing: "Prezzi",
      contact: "Contatti",
      book: "Prenota Taxi",
    },
    common: {
      callNow: "Chiama Ora",
      bookNow: "Prenota Ora",
      bookTaxi: "Prenota Taxi",
      learnMore: "Scopri di più",
      seeAll: "Vedi tutto",
      readMore: "Leggi di più",
      whatsapp: "WhatsApp",
      available247: "24/7 al tuo servizio",
      from: "da",
      to: "a",
      backToHome: "Torna alla Home",
      submit: "Invia",
      submitting: "Invio in corso...",
      success: "Successo!",
      error: "Qualcosa è andato storto",
      fixedPrices: "Prezzi fissi",
      noHiddenFees: "Nessun costo nascosto",
      customers: "clienti",
      capacity: "Capienza",
      luggage: "Bagagli",
      duration: "Durata",
      distance: "Distanza",
      price: "Prezzo",
      waitingPerHour: "Attesa/ora",
      fixedPriceSedan: "Prezzo fisso Sedan",
      flightTracking: "Monitoraggio volo",
      searchDestination: "Cerca destinazione...",
      noResults: "Nessun risultato. Chiama +355 68 22 22 286 per un preventivo personalizzato.",
      all: "Tutti",
      bookYourRide: "Prenota la Corsa",
      callLong: "Chiama +355 68 22 22 286",
      startingFrom: "Da",
    },
    hero: {
      tagline: "Lushnje • Tirana • Costa Albanese",
      title: "A Una Chiamata.",
      subtitle: "Sempre. Ovunque.",
      description: "Brothers Taxi - servizio taxi professionale 24/7 a Lushnje e in tutta l'Albania. Puntualità, comfort premium, prezzi fissi.",
      ctaPrimary: "Prenota Taxi",
      ctaSecondary: "Chiama +355 68 22 22 286",
    },
    stats: {
      years: "Anni di Esperienza",
      trips: "Viaggi Riusciti",
      cities: "Città Coperte",
      support: "Supporto Clienti",
    },
    fleetPreview: {
      tag: "La Nostra Flotta",
      title: "Veicoli moderni per ogni destinazione",
      subtitle: "La nostra flotta unisce veicoli elettrici a modelli premium per viaggi silenziosi, sicuri e confortevoli.",
      viewAll: "Guarda tutta la flotta",
      reserve: "Prenota",
      cars: [
        {
          type: "id4",
          name: "Volkswagen ID.4",
          badge: "SUV Elettrico",
          desc: "SUV elettrico spazioso, ideale per aeroporto e viaggi lunghi.",
          specs: ["4 passeggeri", "3-4 valigie", "Elettrica"],
          footer: "Aeroporto · Lunghe distanze",
        },
        {
          type: "byd",
          name: "BYD Song Plus",
          badge: "SUV Premium Elettrico",
          desc: "Spazio e comfort per famiglie, viaggi di lavoro e turismo.",
          specs: ["4 passeggeri", "4 valigie", "Elettrica"],
          footer: "Famiglia · Turismo · Lavoro",
        },
        {
          type: "gla",
          name: "Mercedes-Benz GLA 2025",
          badge: "SUV Premium",
          desc: "Servizio premium per trasferimenti aziendali, viaggi privati e clienti VIP.",
          specs: ["4 passeggeri", "3 valigie", "Modello 2025"],
          footer: "Business · VIP · Privato",
        },
      ],
    },
    home: {
      whyTitle: "Perché Scegliere Brothers Taxi",
      whySubtitle: "Comfort ad ogni chilometro",
      reasons: [
        { title: "Sempre Puntuali", desc: "Siamo sempre in orario per il tuo volo o viaggio." },
        { title: "Comfort & Pulizia", desc: "Auto premium, pulite, comode per ogni viaggio." },
        { title: "Prezzi Fissi", desc: "Nessuna sorpresa. Il prezzo che vedi è quello che paghi." },
        { title: "Servizio 24/7", desc: "Operiamo giorno e notte, ogni giorno dell'anno." },
        { title: "Autisti Professionisti", desc: "Licenziati, gentili e con grande esperienza." },
        { title: "Copertura Nazionale", desc: "Da Lushnje a qualsiasi città albanese." },
      ],
      destinationsTitle: "Le Nostre Destinazioni più Richieste",
      destinationsSubtitle: "Verso la costa. Verso la città. Verso l'aeroporto.",
      ctaTag: "Prenota il viaggio",
      ctaBlockTitle: "Pronto per il tuo viaggio?",
      ctaBlockSubtitle: "Viaggia con veicoli moderni, autisti professionisti e un servizio organizzato per ogni destinazione in Albania.",
      testimonialsTag: "Recensioni",
      testimonialsTitle: "Cosa dicono i nostri clienti",
      testimonialsScore: "TrustScore",
      testimonialsRatingLabel: "Eccellente",
      testimonialsReviews: "recensioni",
      testimonialsVerified: "Verificato",
      testimonials: [
        { quote: "L'autista ci ha aspettato in aeroporto in orario. L'auto era pulitissima e il viaggio verso Valona è stato tranquillo.", name: "Marco R.", country: "Italia", flag: "🇮🇹", date: "12 gen 2026" },
        { quote: "Comunicazione ottima prima dell'arrivo e servizio professionale durante tutto il trasferimento.", name: "Anna K.", country: "Germania", flag: "🇩🇪", date: "5 gen 2026" },
        { quote: "Prenotazione semplice e autista gentilissimo con i bagagli. Lo useremo di nuovo.", name: "James W.", country: "Regno Unito", flag: "🇬🇧", date: "28 dic 2025" },
        { quote: "Prezzo corretto, auto elettrica molto comoda — la consiglio per andare a Ksamil.", name: "Endri H.", country: "Albania", flag: "🇦🇱", date: "20 dic 2025" },
        { quote: "Un service ponctuel et un chauffeur très aimable. Parfait pour le transfert Rinas–Sarandë.", name: "Camille D.", country: "Francia", flag: "🇫🇷", date: "15 dic 2025" },
        { quote: "Servizio impeccabile, auto elettrica silenziosa e prezzo trasparente. Consigliato al 100%.", name: "Giulia F.", country: "Italia", flag: "🇮🇹", date: "3 dic 2025" },
      ],
    },
    whyBrothers: {
      tag: "Perché Brothers Taxi",
      title: "Un servizio che inizia prima del viaggio",
      subtitle: "Prenotazione, comunicazione e organizzazione sono importanti quanto il viaggio stesso.",
      items: [
        { title: "Prenotazione facile", desc: "Prenota online o contattaci direttamente per organizzare il trasferimento." },
        { title: "Attesa puntuale", desc: "L'autista si organizza secondo l'orario e il punto di ritiro concordato." },
        { title: "Prezzi trasparenti", desc: "Dettagli e prezzo del viaggio confermati prima della partenza." },
        { title: "Supporto 24/7", desc: "Siamo disponibili per modifiche, ritardi voli e richieste speciali." },
      ],
    },
    about: {
      title: "Chi è Brothers Taxi",
      subtitle: "Una storia di famiglia. Un servizio professionale.",
      content: [
        "Brothers Taxi è stata fondata da due fratelli con una visione semplice: offrire all'Albania un servizio taxi che combina l'affidabilità familiare con la professionalità europea.",
        "Dal primo giorno, le nostre priorità sono sicurezza, comfort e puntualità. Ogni viaggio con noi non è solo un trasporto – è un'esperienza premium.",
        "Operiamo da Lushnje verso tutta l'Albania – dall'Aeroporto di Tirana (Rinas) alle bellissime spiagge di Saranda e Ksamil, fino alle città interne.",
      ],
      missionTitle: "La Nostra Missione",
      mission: "Cambiare il modo di viaggiare in Albania – offrendo sicurezza, comfort e affidabilità ad ogni chilometro.",
      visionTitle: "La Nostra Visione",
      vision: "Diventare il servizio di trasporto privato n.1 in Albania, fissando un nuovo standard di qualità nel settore.",
    },
    services: {
      title: "I Nostri Servizi",
      subtitle: "Ogni viaggio - una soluzione",
      items: [
        { name: "Taxi in Città", desc: "Servizio taxi 24/7 a Lushnje e città circostanti.", icon: "MapPin" },
        { name: "Trasferimento Aeroporto", desc: "Trasporto diretto da/per l'Aeroporto di Tirana - prezzi fissi.", icon: "Plane" },
        { name: "Lunga Distanza", desc: "Verso qualsiasi città in Albania con prezzi prestabiliti.", icon: "Route" },
        { name: "Viaggi sulla Costa", desc: "Saranda, Ksamil, Dhermi, Himara, Vlora - la tua estate inizia qui.", icon: "Sun" },
        { name: "Prenotazioni Aziendali", desc: "Accordi speciali per aziende e partner commerciali.", icon: "Briefcase" },
        { name: "Eventi & Matrimoni", desc: "Trasporto elegante per i tuoi giorni speciali.", icon: "Heart" },
      ],
    },
    airport: {
      title: "Trasferimento Aeroporto",
      subtitle: "Aeroporto di Tirana (TIA / Rinas) - sempre puntuali",
      description: "Specialisti del trasferimento da e per l'Aeroporto Internazionale di Tirana. I nostri autisti monitorano il tuo volo in tempo reale.",
      features: [
        "Monitoraggio del volo in tempo reale",
        "L'autista ti aspetta all'uscita con il tuo nome",
        "Nessun costo extra per i ritardi del volo",
        "Prenota fino a 30 giorni in anticipo",
        "Accettiamo contanti, carta e bonifico",
        "Bagaglio illimitato – senza costi extra",
      ],
      ctaTitle: "Prenota Trasferimento Aeroporto",
      ctaDesc: "Assicurati che il tuo volo inizi e finisca senza stress.",
    },
    fleet: {
      title: "La Nostra Flotta",
      subtitle: "Veicoli moderni, elettrici e confortevoli per trasferimenti aeroportuali, viaggi interurbani, viaggi di lavoro e destinazioni in tutta l'Albania.",
      ctaVehicles: "I Nostri Veicoli",
      vehicles: [
        { name: "Volkswagen ID.4", capacity: "1-4 passeggeri", luggage: "3-4 valigie", desc: "Trasferimento aeroporto in stile europeo. SUV elettrico silenzioso, sicuro e comodo — ideale per la tratta Lushnje–Rinas.", type: "id4" },
        { name: "MG MG4", capacity: "1-4 passeggeri", luggage: "2-3 valigie", desc: "Hatchback elettrica dinamica per città e viaggi medi. Veloce, agile e a zero emissioni — scivoli in silenzio.", type: "mg4" },
        { name: "BYD Song Plus", capacity: "1-4 passeggeri", luggage: "3-4 valigie", desc: "SUV elettrico grande e comodo. Il nostro preferito per viaggi lunghi verso Saranda, Ksamil e la Riviera Albanese.", type: "byd" },
      ],
      electric: {
        tag: "Flotta elettrica",
        title: "Viaggi più silenziosi e più puliti",
        subtitle: "La parte principale della nostra flotta è composta da veicoli elettrici. Volkswagen ID.4, BYD Song Plus e MG4 offrono un viaggio silenzioso, confortevole e senza emissioni allo scarico.",
        items: [
          { title: "Veicoli completamente elettrici", desc: "Tecnologia moderna per viaggi sicuri ed efficienti." },
          { title: "Meno rumore durante il viaggio", desc: "Un abitacolo più silenzioso significa più comfort per i passeggeri." },
          { title: "Zero emissioni allo scarico", desc: "Una scelta più responsabile per le città e per l'ambiente." },
        ],
      },
      ctaTitle: "Non sai quale veicolo scegliere?",
      ctaDesc: "Diccisi la destinazione, il numero di passeggeri e la quantità di bagagli. Arriveremo con l'auto giusta per te.",
    },
    pricing: {
      title: "I Nostri Prezzi",
      subtitle: "Chiari. Equi. Senza sorprese.",
      headerFrom: "Partenza",
      headerTo: "Arrivo",
      headerDuration: "Durata",
      headerDistance: "Distanza",
      headerPrice: "Prezzo",
      note: "Prezzi in Lek albanesi (L), per una sola direzione con Sedan. Per SUV +20%, per Van +35%. Tempo di attesa fatturato separatamente. 100 L ≈ 1 €.",
      empty: "Caricamento prezzi...",
    },
    booking: {
      title: "Prenota il Tuo Taxi",
      subtitle: "Compila il modulo e ti contatteremo entro 5 minuti",
      fields: {
        fullName: "Nome Cognome",
        phone: "Telefono",
        email: "Email (opzionale)",
        pickupLocation: "Luogo di partenza",
        dropoffLocation: "Destinazione",
        pickupDate: "Data",
        pickupTime: "Ora",
        passengers: "Passeggeri",
        luggage: "Valigie",
        vehicleType: "Tipo di veicolo",
        serviceType: "Tipo di servizio",
        flightNumber: "Numero di volo (per Aeroporto)",
        notes: "Note aggiuntive",
      },
      vehicleTypes: { sedan: "Sedan", suv: "SUV", van: "Van/Minivan" },
      serviceTypes: { city: "In Città", airport: "Aeroporto", long_distance: "Lunga Distanza", coastal: "Costa" },
      submit: "Conferma Prenotazione",
      success: "Prenotazione inviata con successo! Ti contatteremo a breve.",
      error: "Errore nella prenotazione. Riprova o chiama direttamente.",
      placeholders: {
        fullName: "es. Mario Rossi",
        phone: "+355 68 ...",
        email: "tu@email.com",
        pickup: "es. Centro Lushnje",
        dropoff: "es. Aeroporto Rinas",
        notes: "Richieste speciali, ecc.",
      },
    },
    contact: {
      title: "Contattaci",
      subtitle: "Siamo sempre vicini – una chiamata, messaggio o visita.",
      badge: "Siamo qui",
      openLabel: "Online adesso",
      responseLabel: "Risposta media",
      responseTime: "5 min",
      quickTitle: "Chat rapida",
      quickDesc: "Preferisci WhatsApp? Il tuo messaggio arriva direttamente al nostro team. Prenota, chiedi il prezzo o richiedi una fermata speciale.",
      callTitle: "Chiama",
      emailTitle: "Email",
      whatsappTitle: "WhatsApp",
      locationTitle: "Posizione",
      locationValue: "Lushnje, Albania",
      formTitle: "Inviaci un Messaggio",
      formSubtitle: "Diccisi cosa ti serve – destinazione, orario, richieste speciali. Rispondiamo entro 5 minuti.",
      fields: { name: "Nome", email: "Email", phone: "Telefono", subject: "Oggetto", message: "Messaggio" },
      submit: "Invia Messaggio",
      success: "Messaggio inviato! Risponderemo al più presto.",
      error: "Errore. Riprova.",
    },
    footer: {
      tagline: "Servizio taxi professionale 24/7. Lushnje & tutta l'Albania.",
      quickLinks: "Link Rapidi",
      services: "Servizi",
      contact: "Contatti",
      rights: "Tutti i diritti riservati.",
      legal: "Privacy Policy",
    },
    accents: {
      whereNext: "Dove andare ora?",
      noSurprises: "Nessuna sorpresa —",
      noStress: "Senza stress —",
      fromHeart: "Dal cuore di Lushnje —",
      whateverNeeded: "Qualunque cosa ti serva —",
      hello: "Ciao —",
      premiumComfort: "Comfort premium —",
      soSimple: "Così semplice —",
      trustedOne: "il più affidabile",
      pricingTag: "Tariffe Brothers Taxi",
      airportTag: "Aeroporto",
      coastTag: "Riviera",
    },
    seoBlock: {
      heading1: "Taxi a Lushnje 24/7 —",
      heading2: "il più affidabile",
      heading3: "dei taxi",
      p1: "Brothers Taxi è il servizio taxi più affidabile di Lushnje. Operiamo ogni giorno dell'anno, 24 ore su 24, con una flotta premium e autisti professionisti licenziati. Che tu abbia bisogno di un taxi Lushnje–Tirana, un taxi Lushnje–aeroporto Rinas o un viaggio verso la costa, siamo a una sola chiamata di distanza.",
      p2: "Siamo specializzati nei trasferimenti dall'aeroporto da Lushnje all'Aeroporto Internazionale di Tirana (TIA / Rinas) a un prezzo fisso di 3.500 L, oltre a viaggi a lunga distanza verso Saranda, Ksamil, Dhermi, Himara, Vlora, Durazzo, Berat, Scutari e Korce.",
      p3Pre: "Copriamo anche",
      p3Strong: "i villaggi intorno a Lushnje",
      p3Mid: "e oltre 100 altre destinazioni. Contattaci al",
      p3Post: ".",
    },
    seo: {
    home: {
        title: "Taxi a Lushnje 24/7 | Brothers Taxi - Trasferimento Aeroporto Tirana, Saranda, Ksamil",
        description: "Taxi a Lushnje 24/7 con Brothers Taxi. Prezzi fissi, auto premium, trasferimento Aeroporto Tirana (Rinas) 3500 L, viaggi a Saranda e Ksamil. Chiama +355 68 22 22 286 o prenota online.",
        keywords: "taxi Lushnje, taxi Lushnje Tirana, taxi Lushnje aeroporto, taxi Lushnje Rinas, taxi Saranda da Lushnje, taxi Ksamil da Lushnje, trasferimento aeroporto Lushnje, Brothers Taxi, taxi 24/7 Albania, trasporto privato Lushnje, taxi costa Albania, taxi Vlora Lushnje, taxi Durazzo Lushnje, taxi Albania, prezzi taxi Lushnje, taxi economico Lushnje",
      },
      about: {
        title: "Chi è Brothers Taxi | Compagnia Taxi Familiare a Lushnje, Albania",
        description: "Brothers Taxi è stata fondata da due fratelli con una visione: offrire all'Albania un servizio taxi professionale. La nostra missione, visione e valori. 10+ anni di esperienza, 25.000+ viaggi a Lushnje e in Albania.",
        keywords: "chi è Brothers Taxi, compagnia taxi Lushnje, taxi familiare Albania, taxi professionale Lushnje, storia Brothers Taxi, compagnia trasporti Lushnje, taxi autorizzato Albania",
      },
      services: {
        title: "I Nostri Servizi Taxi | Brothers Taxi Lushnje - Aeroporto, Costa, Aziendale",
        description: "Servizi taxi a Lushnje: taxi in città, trasferimento aeroporto Tirana Rinas, viaggi a lunga distanza in Albania, viaggi sulla costa (Saranda, Ksamil, Dhermi, Himara, Vlora), prenotazioni aziendali, eventi e matrimoni. 24/7.",
        keywords: "servizio taxi Lushnje, trasferimento aeroporto Tirana, taxi città Lushnje, lunga distanza Albania, taxi costa, taxi matrimonio Lushnje, taxi aziendale Albania, taxi per Saranda, taxi per Ksamil, taxi per Dhermi, taxi per Himara, taxi per Vlora, trasporto eventi Lushnje",
      },
      airport: {
        title: "Trasferimento Aeroporto Tirana (Rinas) da Lushnje | Brothers Taxi - 3500 L Fisso",
        description: "Trasferimento in taxi da Lushnje all'Aeroporto Internazionale di Tirana (Rinas / TIA) a 3.500 L fissi. Monitoraggio del volo in tempo reale, autisti autorizzati, senza stress, senza costi nascosti. 24/7. Chiama +355 68 22 22 286.",
        keywords: "trasferimento aeroporto Tirana, taxi Rinas Lushnje, taxi aeroporto Lushnje, trasferimento aeroporto Albania, taxi TIA, taxi Rinas, prezzo Lushnje Rinas, taxi aeroporto Tirana, taxi 24/7 Rinas",
      },
      fleet: {
        title: "La Nostra Flotta | Sedan, SUV & Van Premium - Brothers Taxi Lushnje",
        description: "Veicoli premium per ogni viaggio: Sedan (1-3 passeggeri, Volkswagen/Skoda), SUV comfort (1-4), Van/Minivan (5-8). Pulizia, sicurezza e comfort massimo per il taxi a Lushnje e in tutta l'Albania.",
        keywords: "flotta Brothers Taxi, taxi sedan Lushnje, taxi SUV Lushnje, taxi van Lushnje, taxi gruppi Lushnje, veicoli taxi premium Albania, taxi familiare Lushnje, taxi 8 posti Albania, minivan taxi Albania",
      },
      pricing: {
        title: "Prezzi Taxi da Lushnje | 114+ Destinazioni | Brothers Taxi - Lista Completa",
        description: "Lista completa dei prezzi fissi del taxi da Lushnje: Tirana 4000 L, Rinas 3500 L, Saranda 9000 L, Ksamil 10000 L, Durazzo 3000 L, Vlora 5000 L, Berat 2500 L, Korce 8000 L. Oltre 114 rotte con prezzi trasparenti.",
        keywords: "prezzi taxi Lushnje, tariffe taxi Lushnje, prezzo taxi Lushnje Tirana, prezzo taxi Lushnje Rinas, prezzo taxi Lushnje Saranda, prezzo taxi Lushnje Ksamil, prezzo taxi Lushnje Durazzo, prezzo taxi Lushnje Vlora, prezzo taxi Lushnje Berat, tariffe taxi fisse Albania",
      },
      contact: {
        title: "Contatta Brothers Taxi Lushnje | +355 68 22 22 286 - 24/7 WhatsApp & Email",
        description: "Contatta Brothers Taxi a Lushnje: Telefono +355 68 22 22 286, WhatsApp stesso numero, Email booking@brotherstaxi.al. Indirizzo: Lushnje, Albania. Servizio taxi 24 ore su 24, 7 giorni su 7.",
        keywords: "contatti Brothers Taxi, numero taxi Lushnje, telefono taxi Lushnje, WhatsApp taxi Lushnje, email Brothers Taxi, indirizzo taxi Lushnje, taxi Lushnje 24/7",
      },
      book: {
        title: "Prenota Taxi Online a Lushnje | Brothers Taxi - Conferma in 5 Minuti",
        description: "Prenota un taxi online a Lushnje con Brothers Taxi. Compila il modulo per trasferimento aeroporto, taxi cittadino o viaggio sulla costa. Conferma entro 5 minuti. Oppure chiama direttamente +355 68 22 22 286.",
        keywords: "prenota taxi Lushnje, taxi online Lushnje, prenota taxi Albania, prenota taxi aeroporto Tirana, prenotazione online taxi Lushnje, booking taxi Lushnje",
      },
    },
  },
};

export const LANGS = [
  { code: "sq", label: "SQ", name: "Shqip" },
  { code: "en", label: "EN", name: "English" },
  { code: "it", label: "IT", name: "Italiano" },
];
